import { Routes } from '@angular/router';
import { AuthGuard } from '../auth/auth.guard';

export const paymentProcessingRoutes: Routes = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  {
    path: 'dashboard',
    loadComponent: () =>
      import('./dashboard/payment-processing-dashboard.component').then((m) => m.PaymentProcessingDashboardComponent),
    canActivate: [AuthGuard],
  },
  {
    // ?from=<batch tab> for Back, ?tab=<detail tab> to open on another tab than To be paid.
    path: 'batches/:automatedPaymentBatchId',
    loadComponent: () => import('./batch-detail/batch-detail.component').then((m) => m.BatchDetailComponent),
    canActivate: [AuthGuard],
  },
];
